/**
 * Приводит плоские ряды координат (что редактирует форма) к GeoJSON-геометрии —
 * тем же правилом, что и бэк при создании объекта: одна точка → Point, замкнутое
 * кольцо (≥3 точек, первая = последней) → Polygon, иначе LineString.
 * @param coords
 */
export function coordsToGeometry(coords: number[][]) {
  if (coords.length === 1) return { type: 'Point' as const, coordinates: coords[0] }

  const isClosedRing =
    coords.length > 2 &&
    coords[0][0] === coords[coords.length - 1][0] &&
    coords[0][1] === coords[coords.length - 1][1]

  if (isClosedRing) return { type: 'Polygon' as const, coordinates: [coords] }

  return { type: 'LineString' as const, coordinates: coords }
}

/**
 * Приводит GeoJSON-геометрию карточки объекта к плоским рядам, которые редактирует форма.
 * @param geometry
 */
export function geometryToCoords(
  geometry: { type: string; coordinates: any } | undefined,
): number[][] {
  if (!geometry) return []
  if (geometry.type === 'Point') return [geometry.coordinates]
  if (geometry.type === 'Polygon') return geometry.coordinates[0] ?? []
  return geometry.coordinates
}
